import { combineReducers } from 'redux';

import fetchPlaceDetailsReducerMap, {
    fetchPlaceDetailsAction,
} from './actions/fetchPlaceDetails';
import fetchPlaceFromTextReducerMap, {
    fetchPlaceFromTextAction,
} from './actions/fetchPlaceFromText';
import fetchPlacePredictionsReducerMap, {
    fetchPlacePredictionsAction,
} from './actions/fetchPlacePredictions';
import googleDataReducerMap, {
    selectors as googleDataSelectors,
} from './appstate';
import namespace from './types';

const reducer = combineReducers({
    ...fetchPlacePredictionsReducerMap,
    ...fetchPlaceDetailsReducerMap,
    ...fetchPlaceFromTextReducerMap,

    ...googleDataReducerMap,
});

export {
    fetchPlaceDetailsAction,
    fetchPlaceFromTextAction,
    fetchPlacePredictionsAction,

    googleDataSelectors,
};

export default {
    [namespace]: reducer,
};
